import React from "react";
import {
  FaTruck,
  FaFileInvoice,
  FaMoneyBillWave,
  FaClock,
  FaUserTie,
} from "react-icons/fa";
import { PieChart, Pie, Cell } from "recharts";

export default function LogistSummaryPanel({ data }) {
  if (!data) return null;

  const delivered = data.delivered || 0;
  const notDelivered = data.delayed || 0;
  const open = data.open || 0;
  const total = delivered + notDelivered + open;
  const progress =
    total > 0 ? Math.round(((delivered + notDelivered) / total) * 100) : 0;

  const chartData = [
    { name: "Закрыта", value: delivered, color: "#4CAF50" },
    { name: "Открыта", value: open, color: "#2196F3" },
    { name: "Не доставлено", value: notDelivered, color: "#F44336" },
  ];

  const safeValue = (value) => {
    if (value == null || typeof value === "object") return "—";
    return value;
  };

  const items = [
    { icon: <FaTruck />, label: "Маршрутов", value: safeValue(data.routesTotal) },
    { icon: <FaFileInvoice />, label: "Квитанций", value: safeValue(data.receiptsTotal) },
    { icon: <FaMoneyBillWave />, label: "Сумма", value: safeValue(data.totalAmount) },
    { icon: <FaClock />, label: "Среднее время", value: safeValue(data.avgDeliveryTime) },
    {
      icon: <FaUserTie />,
      label: "Водителей",
      value: `${data.activeDrivers || 0} (${data.topDriver || "—"})`,
    },
  ];

  return (
    <div style={styles.panel}>
      <div style={styles.chartBlock}>
        <PieChart width={52} height={52}>
          <Pie
            data={chartData}
            dataKey="value"
            innerRadius={18}
            outerRadius={25}
            startAngle={90}
            endAngle={450}
            paddingAngle={1}
            isAnimationActive={false}
          >
            {chartData.map((entry, index) => (
              <Cell key={index} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>

        <div style={styles.chartText}>
          <b style={styles.chartValue}>{progress}%</b>
        </div>
      </div>

      <div style={styles.statsRow}>
        {items.map((item, i) => (
          <div key={i} style={styles.stat}>
            <div style={styles.icon}>{item.icon}</div>
            <div style={styles.text}>
              <span style={styles.label}>{item.label}</span>
              <b style={styles.value}>{item.value}</b>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  panel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    background: "#fff",
    border: "1px solid #e0e3eb",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    padding: "6px 10px",
    gap: "0.6rem",
    minHeight: "58px",
    boxSizing: "border-box",
    transition: "all 0.2s ease",
  },

  chartBlock: {
    position: "relative",
    width: 52,
    height: 52,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  chartText: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
  },
  chartValue: {
    fontSize: "0.85rem",
    fontWeight: 700,
    color: "#1a1a2e",
  },

  statsRow: {
    display: "flex",
    alignItems: "center",
    gap: "0.7rem",
    flexWrap: "wrap",
    flex: 1,
  },
  stat: {
    display: "flex",
    alignItems: "center",
    gap: "0.35rem",
    minWidth: "110px",
  },
  icon: {
    color: "#4a6cf7",
    fontSize: "0.9rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "1.05em",
  },
  label: {
    fontSize: "0.7rem",
    color: "#666",
  },
  value: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#1a1a2e",
  },
};
